import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { RoleObj } from '../../../classes/role-obj';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { AuthorizatorService } from '../../../services/authorizator.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserObj } from '../../../classes/user-obj';
import { DataSource } from '@angular/cdk/table';

export interface DialogData {
  role: RoleObj;
  rootFirebasePath: string;
}

export class UsersDatabase {
  dataChange: BehaviorSubject<UserObj[]> = new BehaviorSubject<UserObj[]>([]);
  get data(): UserObj[] { return this.dataChange.value; }

  constructor() { }
}

export class UsersDataSource extends DataSource<any> {
  constructor(private usersDatabase: UsersDatabase) {
    super();
  }

  connect(): Observable<UserObj[]> {
    return this.usersDatabase.dataChange;
  }

  disconnect() {}
}

@Component({
  selector: 'lib-upsert-role',
  templateUrl: './upsert-role.component.html',
  styleUrls: ['./upsert-role.component.scss']
})
export class UpsertRoleComponent implements OnInit {
  public displayedColumns = ['remove', 'user'];
  private usersDatabase = new UsersDatabase();
  public usersDataSource: UsersDataSource | null;
  public users: UserObj[] = [];
  public roleUsers: UserObj[] = [];
  @ViewChild('selectUser') public selectUser: MatSelect;

  public roleForm = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    description: new FormControl(null),
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authorizatorservice: AuthorizatorService,
    public dialogRef: MatDialogRef<UpsertRoleComponent>
  ) { }

  ngOnInit() {
    this.usersDataSource = new UsersDataSource(this.usersDatabase);
    this.authorizatorservice.getUsers(this.data.rootFirebasePath).then(users => {
      if (users) {
        this.users = users.sort((prev, curr) => {
          if (prev.data.name > curr.data.name) {
            return 1;
          }
          if (prev.data.name < curr.data.name) {
            return -1;
          }
          return 0;
        });
        this.roleUsers = this.users.filter(
          user => this.data && this.data.role && this.data.role.data.users.findIndex(usr => usr === user.id) > -1
        );
        if (this.roleUsers) {
          this.roleUsers = this.roleUsers.sort((prev, curr) => {
            if (prev.data.name > curr.data.name) {
              return 1;
            }
            if (prev.data.name < curr.data.name) {
              return -1;
            }
            return 0;
          });
          this.usersDatabase.dataChange.next(this.roleUsers);
        }
      }
    });
    if (this.data.role) {
      this.roleForm.controls.name.setValue(this.data.role.data.name);
      this.roleForm.controls.description.setValue(this.data.role.data.description);
    }
  }

  onAddUserToRole() {
    const existUser = this.roleUsers.findIndex(roleUser => roleUser.id === this.selectUser.value);
    if (existUser === -1) {
      this.roleUsers.push(this.users.find(user => user.id === this.selectUser.value));
      this.roleUsers = this.roleUsers.sort((prev, curr) => {
        if (prev.data.name > curr.data.name) {
          return 1;
        }
        if (prev.data.name < curr.data.name) {
          return -1;
        }
        return 0;
      });
      this.usersDatabase.dataChange.next(this.roleUsers);
    }
  }

  onRemoveUserFromRole(user: UserObj) {
    const userIndex = this.roleUsers.findIndex(roleUser => roleUser.id === user.id);
    if (userIndex > -1) {
      this.roleUsers.splice(userIndex, 1);
      this.usersDatabase.dataChange.next(this.roleUsers);
    }
  }

  onSubmitRole() {
    if (this.roleForm.valid) {
      const roleToAdd: RoleObj = {
        id: this.data.role ? this.data.role.id : null,
        data: {
          name: this.roleForm.controls.name.value,
          description: this.roleForm.controls.description.value,
          users: this.roleUsers.map(user => user.id),
          permissions: null
        }
      };
      if (roleToAdd.id) {
        this.authorizatorservice.updateRole(this.data.rootFirebasePath, roleToAdd).then(() => {
          this.dialogRef.close(roleToAdd);
        }).catch(error => {
          this.roleForm.controls.name.setErrors({ defaulterror: true });
        });
      } else {
        this.authorizatorservice.addRole(this.data.rootFirebasePath, roleToAdd).then(() => {
          this.dialogRef.close(roleToAdd);
        }).catch(error => {
          if (error.key === 'exists') {
            this.roleForm.controls.name.setErrors({ exists: true });
          } else {
            this.roleForm.controls.name.setErrors({ defaulterror: true });
          }
        });
      }
    }
  }
}
